import './components/labels-explainer';
import './components/scroll-fadein';
import './components/header';
import { openSearch } from './components/autocomplete-search';
import { initializeLocationSwitchModal } from './components/location-switch-modal';
import { getResponsiveBreakpoint } from './util/breakpoint';
import favorite from './components/favorite';
import account from './components/account';
import { getUploadedImage } from './components/pixyle';
import feedbackAndShare from './vue/components/FeedbackAndShare.vue';
import * as tracking from './util/tracking';
import './util/adwords';

var responsiveBreakpoint = getResponsiveBreakpoint();

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

const loginModal = new window.bootstrap.Modal(
  document.getElementById('login-modal')
);

initializeModals();

document.addEventListener('DOMContentLoaded', function () {
  // Show GDPR info on focus of newletter input
  document.getElementById('sib-EMAIL').addEventListener('focus', function () {
    document.getElementById('mergeRow-gdpr').classList.remove('d-none');
  });

  setRegisterButtonListener();

  document.querySelectorAll('.account-link').forEach($link => {
    $link.addEventListener('click', function (e) {
      // If user is not logged in, open login modal
      if (!account.isAuthenticated()) {
        e.preventDefault();
        loginModal.show();
      }
    });
  });

  // Tooltips
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(function (tooltipTriggerEl) {
      return new window.bootstrap.Tooltip(tooltipTriggerEl);
    });

  // Set listeners
  setProductImageClickListeners();
  setMobileSidebarListeners();
  setSearchButtonListeners();

  // Focus email field when opening login modal
  document
    .getElementById('login-modal')
    .addEventListener('shown.bs.modal', function () {
      document.getElementById('email').focus();
      _paq.push(['trackEvent', 'Login', 'FromNavbar', '-']);
    });

  // Interaction of removing header search section pre-filter
  const clearSearchSection = document.getElementById(
    'clear-search-section-button'
  );
  if (clearSearchSection) {
    clearSearchSection.addEventListener('click', function () {
      window.cece.searchSection = null;
      clearSearchSection.parentElement.parentElement.classList.remove(
        'has-section'
      );
      clearSearchSection.parentElement.remove();
    });
  }

  // Track catalog search form submission
  const catalogSearchForms = document.getElementsByClassName(
    'search-catalog-form'
  );
  for (let form of catalogSearchForms) {
    form.addEventListener('submit', event => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const query = formData.get('query');
      tracking.trackEvent('CatalogSearch', 'ManualSearch', query);
      setTimeout(() => {
        event.target.submit();
      }, 100);
    });
  }

  // Track referrer
  isFairProReferrer();

  setupStickyHeader();

  // Vue app for feedback and share popup
  new Vue({
    el: '#feedback-and-share-popup',
    components: {
      feedbackAndShare,
    },
    render: h => h(feedbackAndShare),
  });

  /**
   * Buttons with the class `.destination-button` navigate to the url defined
   * in data-destination when clicked
   */
  (function () {
    const links = [].slice.call(
      document.getElementsByClassName('destination-button')
    );
    if (!links || links.length === 0) {
      return;
    }
    links.forEach(link => {
      link.addEventListener('click', event => {
        const destination =
          event.currentTarget.getAttribute('data-destination');
        if (destination) {
          event.preventDefault();
          window.location.href = destination;
        }
      });
    });
  })();

  // Login
  setupLoginForm();
  setupSignupForm();
  setupNewsletterForm();
});

async function initializeModals() {
  // First see if location switch modal is showing up
  const isShowingLocationSwitchModal = initializeLocationSwitchModal({
    onHide() {
      // If yes, wait for the location switch modal to close before
      // showing cookiebar
      window.cookies.showCookiebanner();
    },
  });

  // If not, show cookiebar
  if (!isShowingLocationSwitchModal) {
    window.cookies.showCookiebanner();
  }
}

function setRegisterButtonListener() {
  // Switch to register tab using register button in login tab of login modal
  var registerButton = document.querySelector('button#open-register-tab');
  var registerTabButton = document.querySelector(
    '.modal-dialog-login a[href="#register"]'
  );
  var registerTab = new window.bootstrap.Tab(registerTabButton);
  registerButton.addEventListener('click', function () {
    registerTab.show();
  });
}

// Set referrer FairPro cookie for 30 days if referrer parameter in current url
function isFairProReferrer() {
  if (window.location.search.indexOf('fairpub=') > -1) {
    var fairpub = (window.location.search.split('fairpub=')[1] || '').split(
      '&'
    )[0];
    window.cookies.setCookie('refpartner', fairpub, 30);
    console.log('set refpartner cookie');
    console.log(fairpub);
  }
}

function setupStickyHeader() {
  // Give header a .is-sticky class on being sticky
  // and body a .scrolled class
  // https://stackoverflow.com/a/57991537/1515053
  if (window.IntersectionObserver) {
    var stickyElm = document.querySelector('header');
    var observer = new window.IntersectionObserver(
      function (e) {
        e[0].target.classList.toggle('is-sticky', e[0].intersectionRatio < 1);
        document.body.classList.toggle('scrolled', e[0].intersectionRatio < 1);
      },
      { threshold: [1] }
    );
    observer.observe(stickyElm);
  }
}

function setupLoginForm() {
  const $signinForm = document.querySelector('.form-signin');
  const $error = document.getElementById('signin-error-message');
  if ($signinForm) {
    $signinForm.addEventListener('submit', async function (event) {
      event.preventDefault();

      // Hide error message
      $error.classList.add('d-none');
      $error.innerText = '';

      // Convert form data to object + retrieve csrf token
      const formData = new FormData(event.target);
      const formProps = {};
      formData.forEach((value, key) => (formProps[key] = value));
      // const csrftoken = window.cookies.getCookie('csrftoken'); //formProps.csrfmiddlewaretoken;
      const csrftoken = document.querySelector(
        '[name=csrfmiddlewaretoken]'
      ).value;
      delete formProps.csrfmiddlewaretoken;

      try {
        // Post data
        const json = await fetch($signinForm.getAttribute('action'), {
          method: $signinForm.getAttribute('method'),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrftoken,
          },
          body: JSON.stringify(formProps),
        });
        const data = await json.json();

        // Expected error: show error
        if (data.error) {
          $error.innerText = data.error;
          $error.classList.remove('d-none');
          return;
        }

        // Success
        // Store user id
        if (data.userId) {
          account.setUserData(data.userId, data);
        }
        // Store user favorites
        if (data.favorites) {
          favorite.update(data.favorites);
        }
        // Redirect to new destination
        window.location.replace(data.redirect);
      } catch (err) {
        console.error('Error while signing in:', err);

        // Unexpected error
        $error.innerText = window.i18n.general.error;
        $error.classList.remove('d-none');
      }
    });
  }
}

function setupSignupForm() {
  const $signupForm = document.getElementById('user-sign-up-form');
  const $error = document.getElementById('signup-error-message');
  const $panel = document.getElementById('sign-up-panel');

  if (!$signupForm) {
    return;
  }

  $signupForm.addEventListener('submit', async function (event) {
    event.preventDefault();

    // Hide error message
    $error.classList.add('d-none');
    $error.innerText = '';

    // Serialize from data + retrieve csrf token
    const formData = new FormData(event.target);
    // const csrftoken = formData.get('csrfmiddlewaretoken');
    // const csrftoken = window.cookies.getCookie('csrftoken');
    const csrftoken = document.querySelector(
      '[name=csrfmiddlewaretoken]'
    ).value;
    formData.delete('csrfmiddlewaretoken');
    const queryString = new URLSearchParams(formData).toString();

    try {
      const json = await fetch($signupForm.getAttribute('action'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRFToken': csrftoken,
        },
        body: queryString,
      });
      const data = await json.json();
      if (data.content) {
        $panel.outerHTML = data['content'];
        if (data.type && data.type === 'success') {
          // Success, track signup
          tracking.trackEvent('UserSignup', 'Signup from standard form');
        } else {
          // Failure, rebind events to form because it has been re-rendered
          setupSignupForm();
        }
      } else {
        $error.innerText = window.i18n.general.error;
        $error.classList.remove('d-none');
      }
    } catch (err) {
      console.error('Error during user sign-up:', err);

      // Unexpected error
      $error.innerText = window.i18n.general.error;
      $error.classList.remove('d-none');
    }
  });
}

function setupNewsletterForm() {
  const $form = document.getElementById('sib-signup-movement-footer');
  const $success = document.getElementById(
    'sib-signup-movement-footer-success'
  );
  const $error = document.getElementById('sib-signup-movement-footer-error');
  const $optInError = document.getElementById('sib-signup-opt-in-error');

  if (!$form) return;

  $form.addEventListener('submit', async function (event) {
    event.preventDefault();

    // Reset error message
    $error.innerText = '';
    $error.classList.add('d-none');
    $optInError.innerText = '';
    $optInError.classList.add('d-none');

    // Serialize from data + retrieve csrf token
    const formData = new FormData(event.target);
    // const csrftoken = formData.get('csrfmiddlewaretoken');
    // const csrftoken = window.cookies.getCookie('csrftoken');
    const csrftoken = document.querySelector(
      '[name=csrfmiddlewaretoken]'
    ).value;
    formData.delete('csrfmiddlewaretoken');
    const queryString = new URLSearchParams(formData).toString();

    try {
      const json = await fetch($form.getAttribute('action'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRFToken': csrftoken,
        },
        body: queryString,
      });
      const data = await json.json();
      if (data.success) {
        $form.classList.add('d-none');
        $success.innerText = data.message[0];
        $success.classList.remove('d-none');
        return;
      } else if (data.message.email) {
        $error.innerText = data.message.email[0];
        $error.classList.remove('d-none');
      } else if (data.message.opt_in) {
        $optInError.innerText = data.message.opt_in[0];
        $optInError.classList.remove('d-none');
      } else {
        console.error('Unknown error during newsletter sign-up', data);
      }
    } catch (err) {
      console.error('Error during newsletter sign-up:', err);
    }
  });
}

function toLogin(productid) {
  // Function triggered when an item is favorited but the user is not logged in.
  // Saves the item as cookie so that it can be added after login, and brings
  // user to login/register modal.
  var expiration = new Date();
  expiration.setTime(expiration.getTime() + 30 * 24 * 60 * 60 * 1000);
  document.cookie = 'fav=' + productid + '; path=/';

  loginModal.show();

  if (window.isProductModalOpen) {
    window.closeProductModal();
    _paq.push(['trackEvent', 'Login', 'FromFavorite', 'ModalHeart']);
  } else {
    _paq.push(['trackEvent', 'Login', 'FromFavorite', 'CatalogHeart']);
  }
}

function getParentWithClass(element, className) {
  let current = element;
  while (current) {
    current = current.parentElement;
    if (current.classList.contains(className)) {
      return current;
    }
  }
  return null;
}

function setProductImageClickListeners() {
  document.querySelectorAll('.productdetail-view').forEach(function ($view) {
    setProductImageClickListener($view);
  });
}

function setProductImageClickListener($productDetailView) {
  // Display the image that is clicked on.
  const mainPicture = $productDetailView.querySelector('.grote-foto');
  $productDetailView
    .querySelectorAll('.productdetail-view .photo-gallery .photo')
    .forEach($photo => {
      $photo.addEventListener('click', function (e) {
        e.preventDefault();
        // Update src of main image to the photo that was clicked on
        mainPicture.setAttribute(
          'src',
          $photo.querySelector('img').getAttribute('data-image')
        );
        // Set the zoom-image src so that the zooms knows what to show
        mainPicture.setAttribute(
          'data-zoom-image',
          $photo.querySelector('img').getAttribute('data-zoom-image')
        );
        // Update thumbnail to show which photo is activ
        $productDetailView
          .querySelector('.photo.active')
          .classList.remove('active');
        $photo.classList.add('active');
        // Reset zoom
        if (window.resetProductPageZoom) {
          window.resetProductPageZoom();
        }
      });
    });
}

function setSearchButtonListeners() {
  // On button click add class to parent element so that
  // form element can be shown, and other elements can be
  // hidden to make space
  const $input = document.querySelector('.open-search-input');
  if (!$input) return;
  $input.addEventListener('click', function (e) {
    e.preventDefault();
    openSearch();
  });
}

function getBaseUrl() {
  return window.location.origin;
}

function scrollToElementById(id) {
  var el = document.getElementById(id);

  if (el !== null) el.scrollIntoView({ behavior: 'smooth' });
}

function closeSidebar($sidebar, resetBody) {
  if (resetBody) {
    document.body.classList.remove('no-scroll');
  }

  // Hide 'show products button'
  // $sidebar.find('.button-show-products').addClass('d-none');

  // Close all pages
  $sidebar.querySelectorAll('.sidebar-page.open').forEach(function ($page) {
    $page.classList.remove('open');
  });

  // Hide page back button
  const $pageBackButton = $sidebar.querySelector('.page-back-button');
  if ($pageBackButton) {
    $pageBackButton.classList.add('d-none');
  }
  // Close sidebar
  $sidebar.classList.remove('open');
}

function closeAllSidebars() {
  document.body.classList.remove('no-scroll');
  document.querySelectorAll('.mobile-sidebar').forEach(function ($sidebar) {
    closeSidebar($sidebar, false);
  });
}

/**
 * Open a specific sidebar
 * @param {String|HTMLElement} el
 */
function openMobileSidebarButton(el) {
  if (typeof el === 'string' || el instanceof String) openMobileSidebar(el);
  else openMobileSidebar(el.getAttribute('data-sidebar'));
}

function openMobileSidebar(id) {
  const $sidebar = document.querySelector(
    `.mobile-sidebar[data-sidebar="${id}"]`
  );
  if ($sidebar.classList.contains('open')) {
    $sidebar.classList.remove('open');
    document.body.classList.remove('no-scroll');
  } else {
    $sidebar.classList.add('open');
    document.body.classList.add('no-scroll');
  }
}

function openSidebarPage($sidebar, $page) {
  $sidebar.querySelectorAll('.page-back-button').forEach(function ($button) {
    $button.classList.remove('d-none');
    $page.classList.add('open');
  });
}

/**
 * Find all the open sidebars pages (including nested once),
 * assume the last one is the deepest one open
 */
function sidebarPageBack($sidebar) {
  // In case the function is called from HTML onclick
  if (!$sidebar.classList.contains('mobile-sidebar')) {
    $sidebar = getParentWithClass($sidebar, 'mobile-sidebar');
  }

  var $openSidebarPages = Array.from(
    $sidebar.querySelectorAll('.sidebar-page.open')
  );
  $openSidebarPages[$openSidebarPages.length - 1].classList.remove('open');
  if ($openSidebarPages.length === 1) {
    $sidebar.querySelector('.page-back-button').classList.add('d-none');
  }
}

function setMobileSidebarListeners() {
  document
    .querySelectorAll('.mobile-sidebar-toggle')
    .forEach(function ($toggle) {
      $toggle.addEventListener('click', function () {
        openMobileSidebar($toggle.getAttribute('data-sidebar'));
      });
    });

  document.querySelectorAll('.mobile-sidebar').forEach(function ($sidebar) {
    // Open sidebar page
    $sidebar.querySelectorAll('.page-button').forEach(function ($button) {
      $button.addEventListener('click', function (e) {
        // On mobile (when the sidebar is active) don't follow the <a> or whatever
        // the button is
        const style = getComputedStyle($sidebar);
        if (style.getPropertyValue('position') === 'fixed') {
          e.preventDefault();
        }
        const $page = getParentWithClass($button, 'sidebar-page');
        openSidebarPage($sidebar, $page);
      });
    });

    // Sidebar page back button
    $sidebar.querySelectorAll('.page-back-button').forEach(function ($button) {
      $button.addEventListener('click', function () {
        sidebarPageBack($sidebar);
      });
    });

    // Close sidebar button
    $sidebar
      .querySelectorAll('.close-sidebar-button')
      .forEach(function ($button) {
        $button.addEventListener('click', function () {
          closeSidebar($sidebar, true);
        });
      });
  });
}

export {
  // Breakpoint info
  responsiveBreakpoint,
  getResponsiveBreakpoint,
  // Components
  account,
  favorite,
  // Tracking
  tracking,
  // Pixyl
  getUploadedImage,
  // main.js
  sidebarPageBack,
  openMobileSidebarButton,
  toLogin,
  setProductImageClickListener,
  getBaseUrl,
  scrollToElementById,
  closeAllSidebars,
};
